/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { DomainItemDTO } from '@api/models/.';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'domainValue',
  standalone: false
})
export class DomainValuePipe implements PipeTransform {
  /**
   * mappa per conservare le associazioni chiave/valore e velocizzare l'accesso
   */
  private memory: { [key: string]: string } = {};

  transform(key: string, options: DomainItemDTO[]): string {
    if (!key) {
      return key;
    }

    let val = this.getValFromMemory(key);

    if (val) {
      return val;
    }

    val = this.getValFromOptions(key, options);

    if (val) {
      this.setValOnMemory(key, val);
      return val;
    }

    return key;
  }

  private getValFromOptions(key: string, options: DomainItemDTO[]): string {
    const option = options.find(x => x.key === key);

    return (option && option.value) || null;
  }

  private getValFromMemory(key: string): string {
    return this.memory[key] || null;
  }

  private setValOnMemory(key: string, value: string): void {
    this.memory[key] = value;
  }
}
